<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['categories']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true
            }),
            {
              component: 'h3',
              innerText: 'Kategorie'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'categories'],
              blankObject: { subcategories: [] },
              items: this.form.categories.map((item, i) => ({
                headerLabel: get(item, ['title']),
                fields: [
                  new fields.Input({
                    label: 'Tytuł',
                    modelPath: [this, 'form', 'categories', i, 'title'],
                    required: true
                  }),
                  new fields.WYSIWYG({
                    label: 'Treść',
                    modelPath: [this, 'form', 'categories', i, 'text']
                  }),
                  new fields.WYSIWYG({
                    label: 'Przykłady prac tekst',
                    modelPath: [this, 'form', 'categories', i, 'examples_text']
                  }),
                  new fields.Link({
                    label: 'Przykłady prac link',
                    modelPath: [this, 'form', 'categories', i, 'examples_link']
                  }),
                  new fields.RelatedCategories({
                    label: 'Pokrewne kategorie',
                    modelPath: [
                      this,
                      'form',
                      'categories',
                      i,
                      'related_categories'
                    ]
                  }),
                  new fields.Switch({
                    label: 'Oznacz jako nowa',
                    modelPath: [this, 'form', 'categories', i, 'is_new']
                  }),
                  {
                    component: 'h3',
                    innerText: 'Podkategorie'
                  },
                  this.getSubcategoriesFormset(
                    this.form.categories[i].subcategories,
                    i
                  )
                ]
              }))
            })
          ]
        }
      ]
    }
  },
  methods: {
    getSubcategoriesFormset(subcategories, categoryIndex) {
      return new fields.Formset({
        modelPath: [this, 'form', 'categories', categoryIndex, 'subcategories'],
        items: subcategories.map((subcategory, subcategoryIndex) => {
          return {
            headerLabel: get(subcategory, ['title']),
            fields: [
              new fields.Input({
                label: 'Tytuł',
                required: true,
                modelPath: [
                  this,
                  'form',
                  'categories',
                  categoryIndex,
                  'subcategories',
                  subcategoryIndex,
                  'title'
                ]
              }),
              new fields.WYSIWYG({
                label: 'Treść',
                modelPath: [
                  this,
                  'form',
                  'categories',
                  categoryIndex,
                  'subcategories',
                  subcategoryIndex,
                  'text'
                ]
              }),
              new fields.Link({
                label: 'Przykłady prac link',
                modelPath: [
                  this,
                  'form',
                  'categories',
                  categoryIndex,
                  'subcategories',
                  subcategoryIndex,
                  'examples_link'
                ]
              }),
              new fields.WYSIWYG({
                label: 'Przykłady prac tekst',
                modelPath: [
                  this,
                  'form',
                  'categories',
                  categoryIndex,
                  'subcategories',
                  subcategoryIndex,
                  'examples_text'
                ]
              }),
              new fields.RelatedCategories({
                label: 'Pokrewne kategorie',
                modelPath: [
                  this,
                  'form',
                  'categories',
                  categoryIndex,
                  'subcategories',
                  subcategoryIndex,
                  'related_categories'
                ]
              }),
              new fields.Switch({
                label: 'Oznacz jako nowa',
                modelPath: [
                  this,
                  'form',
                  'categories',
                  categoryIndex,
                  'subcategories',
                  subcategoryIndex,
                  'is_new'
                ]
              }),
            ]
          }
        })
      })
    }
  }
}
</script>
